



























import { defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { InputGroupMembersUpdate } from "@scrile/api-provider/dist/api/GroupsProvider";
import { useGroups } from "@/hooks/useGroups";
import useOnChangePage from "@/hooks/useOnChangePage";
import providers from "@/lib/api";
import AddNewGroup from "@/components/AddNewGroup";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import GroupList from "@/components/GroupList";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "GroupModal",
  components: { ModalView, GroupList, BaseCheckbox, PageTitle, BaseButton, AddNewGroup },
  props: {
    show: { type: Boolean, required: true },
    userId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const { getData, groups } = useGroups();
    const checkedGroups = ref<Record<string, boolean>>({});
    const anyChanges = ref<boolean>(false);
    const loadingButton = ref<boolean>(false);

    watch(
      [toRef(props, "userId"), groups],
      ([userId]) => {
        groups.value.forEach(group => {
          if (group.memberIds.includes(userId as string)) {
            checkedGroups.value = { ...checkedGroups.value, [group.id]: true };
          }
        });
      },
      { immediate: true }
    );

    useOnChangePage(() => emit("close"));

    const updateGroupList = async () => {
      await getData();
    };

    const checkboxChange = (value: boolean, id: string) => {
      checkedGroups.value = { ...checkedGroups.value, [id]: value };
      anyChanges.value = true;
    };

    const onSave = async () => {
      const selectedGroups: InputGroupMembersUpdate[] = [];
      for (const id in checkedGroups.value) {
        selectedGroups.push({
          id,
          memberId: props.userId,
          status: checkedGroups.value[id],
        });
      }
      try {
        loadingButton.value = true;
        await providers.GroupsProvider.updateMembers({ data: selectedGroups });
        anyChanges.value = false;
        emit("close");
      } finally {
        loadingButton.value = false;
      }
    };

    getData();

    return {
      groups,
      checkedGroups,
      loadingButton,
      anyChanges,
      checkboxChange,
      updateGroupList,
      onSave,
    };
  },
});
